import getConfig from 'next/config';
import mapValues from 'lodash/mapValues';
import parseUrl from 'url-parse';

export const isMatchingPath = paths =>
  paths
    .map(path => parseUrl(path, {}).pathname)
    .every((pathname, _, pathnames) => pathname === pathnames[0]);

export const getLoggingUri = () => {
  const { publicRuntimeConfig = {} } = getConfig() || {};
  const { logPath = '' } = publicRuntimeConfig;

  return window.location.origin + logPath;
};

export const convertNumericStringPropToInt = object => {
  return mapValues(object, (value, key) => {
    if (typeof value === 'string' && value.match(/^-{0,1}\d+$/)) {
      return parseFloat(value);
    }

    return value;
  });
};

export const baseUrls = {
  checkin: '/online-checkin',
};
